import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { xhrTracer } from './XHRTracer.js'
let faro = null

// Initialize Faro
if (import.meta.env.VITE_FARO_API_KEY && import.meta.env.VITE_FARO_URL) {
  faro = initializeFaro({
    url: import.meta.env.VITE_FARO_URL,
    apiKey: import.meta.env.VITE_FARO_API_KEY,
    app: {
      name: 'agentnoon-frontend',
      version: import.meta.env.VITE_VERSION || 'dev'
    },
    consoleInstrumentation: {
      consoleErrorAsLog: true,
      serializeErrors: true,
      disabledLevels: []
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true
      }),
      new TracingInstrumentation({
        resourceAttributes: {
          'deployment.PR': import.meta.env.VITE_PR_NUMBER || 'unknown'
        },
        instrumentations: []
      })
    ]
  })
  xhrTracer.init(faro)
}

export { faro }
